module.exports = __webpack_public_path__ + "img/pim.4e791819.png";